import { AudiosConfig } from '@/scenarios/legacy-player/components/Player';

import { Track, JoinDataLeft, JoinDataRight } from '../Tracks.types';

export const useInnerJoinAudioTracks = (
    // eslint-disable-next-line default-param-last
    tracksFromPlayer: readonly Track[] = [],
    tracksFromCurrentStream?: AudiosConfig
) =>
    useInnerJoin(
        { data: tracksFromPlayer, getKey: (track) => track.lang },
        { data: tracksFromCurrentStream, getKey: (track) => track.language }
    );

function useInnerJoin<T2, T1 extends { info?: T2 }>(
    dataLeft: JoinDataLeft<T1>,
    dataRight: JoinDataRight<T2>
): Map<string, T1> {
    const map = new Map<string, T1>();

    if (!dataRight.data || dataRight.data.length === 0) {
        return map;
    }

    const rightKeys = new Set(dataRight.data.map((trackRight) => dataRight.getKey(trackRight)));

    dataLeft.data.forEach((trackLeft) => {
        const key = dataLeft.getKey(trackLeft);
        if (rightKeys.has(key)) {
            const matchingRightTrack = dataRight.data?.find(
                (trackRight) => dataRight.getKey(trackRight) === key
            );
            if (matchingRightTrack) {
                map.set(key, {
                    ...trackLeft,
                    info: matchingRightTrack,
                });
            }
        }
    });

    return map;
}
